import { Crown, Star, Sparkles } from "lucide-react";

export const PlanBadge = ({ planType, size = "default" }) => {
  const isPremium = planType === "advanced";
  
  if (!isPremium) return null;
  
  const sizeClasses = {
    small: "px-2 py-0.5 text-xs",
    default: "px-3 py-1 text-sm",
    large: "px-4 py-1.5 text-base"
  };
  
  return (
    <div className={`
      inline-flex items-center gap-1.5 
      bg-gradient-to-r from-emerald-600 to-emerald-500 
      text-white font-semibold rounded-full
      ${sizeClasses[size]}
    `}>
      <Crown className={size === "small" ? "w-3 h-3" : "w-4 h-4"} />
      <span>PRO</span>
    </div>
  );
};

export const PlanIndicator = ({ planType, showLabel = true }) => {
  const isPremium = planType === "advanced";
  
  return (
    <div className={`
      flex items-center gap-2 px-3 py-1.5 rounded-lg
      ${isPremium 
        ? "bg-gradient-to-r from-emerald-50 to-green-50 border border-emerald-200" 
        : "bg-navy-100 border border-navy-200"
      }
    `}>
      {isPremium ? (
        <>
          <Crown className="w-4 h-4 text-emerald-600" />
          {showLabel && <span className="text-sm font-medium text-emerald-700">Plan Avanzado</span>}
        </>
      ) : (
        <>
          <Star className="w-4 h-4 text-navy-500" />
          {showLabel && <span className="text-sm font-medium text-navy-600">Plan Standard</span>}
        </>
      )}
    </div>
  );
};

export const FeatureGate = ({ feature, planFeatures, children, fallback }) => {
  const hasAccess = planFeatures?.[feature] === true;
  
  if (hasAccess) {
    return children;
  }
  
  return fallback || null;
};

export const PremiumFeatureCard = ({ title, description, icon: Icon, locked = false, onClick }) => {
  return (
    <div 
      onClick={locked ? undefined : onClick}
      className={`
        card-elevated p-6 transition-all duration-300
        ${locked 
          ? "opacity-60 cursor-not-allowed" 
          : "hover:border-emerald-300 hover:-translate-y-1 cursor-pointer"
        }
      `}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
          locked ? "bg-navy-100" : "bg-emerald-100"
        }`}>
          <Icon className={`w-6 h-6 ${locked ? "text-navy-400" : "text-emerald-600"}`} />
        </div>
        {locked && (
          <div className="flex items-center gap-1 px-2 py-1 bg-emerald-100 rounded-full">
            <Sparkles className="w-3 h-3 text-emerald-600" />
            <span className="text-xs font-medium text-emerald-700">PRO</span>
          </div>
        )}
      </div>
      <h3 className={`font-semibold mb-1 ${locked ? "text-navy-500" : "text-navy-900"}`}>
        {title}
      </h3>
      <p className={`text-sm ${locked ? "text-navy-400" : "text-navy-600"}`}>
        {description}
      </p>
      {locked && (
        <p className="text-xs text-emerald-600 mt-3 font-medium">
          Disponible en Plan Avanzado
        </p>
      )}
    </div>
  );
};

export default PlanBadge;
